'use client';

import { useLocale } from 'next-intl';
import { usePathname, useRouter } from '@/i18n/navigation';
import type { Locale } from '@/i18n/routing';

export function LanguageSwitcher() {
  const locale = useLocale();
  const pathname = usePathname();
  const router = useRouter();

  const switchLocale = (newLocale: Locale) => {
    router.replace(pathname, { locale: newLocale });
  };

  return (
    <div className="flex items-center gap-1 text-sm">
      <button
        onClick={() => switchLocale('ru')}
        className={`px-2 py-1 rounded transition-colors ${
          locale === 'ru'
            ? 'text-ink font-semibold'
            : 'text-whisper hover:text-graphite'
        }`}
      >
        RU
      </button>
      <span className="text-whisper">|</span>
      <button
        onClick={() => switchLocale('en')}
        className={`px-2 py-1 rounded transition-colors ${
          locale === 'en'
            ? 'text-ink font-semibold'
            : 'text-whisper hover:text-graphite'
        }`}
      >
        EN
      </button>
    </div>
  );
}
